import { makeStub } from "./_base";
export const Product = makeStub("Product");
